import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/saved_strategies",
	lazy(() => import("./AdminSavedStrategiesPage"))
);
